export {
  ENTITY_STATUS_ACTIVE_INACTIVE_OPTIONS as PRODUCT_STATUS_FILTER_OPTIONS,
  formatEntityStatusLabel as formatProductStatusLabel,
} from '#/modules/commonComponents/table/entityStatus';

export function canActivateProduct(status) {
  return status === 'INACTIVE';
}

export function canDeactivateProduct(status) {
  return status === 'ACTIVE';
}
